// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ClientSummaryReportAudit [selector=name] {
  text-align: start;
}
.ClientSummaryReportAudit .VirtualTable-Expanded [selector=name] {
  text-align: center;
}
.ClientSummaryReportAudit .VirtualTable-Expanded .VirtualTable-Expanded [selector=name] {
  text-align: end;
}

.Report,
.ClientSummaryReportAudit,
.ReportDetails {
  font-family: Inter, sans-serif, Verdana !important;
}
.Report .Details .row .col,
.ClientSummaryReportAudit .Details .row .col,
.ReportDetails .Details .row .col {
  padding: 0;
}
.Report .VirtualTable-Container,
.ClientSummaryReportAudit .VirtualTable-Container,
.ReportDetails .VirtualTable-Container {
  --vt-header-background: var(--bs-primary);
  border: 1px solid #ccc;
  border-radius: 2px;
  overflow: hidden;
}
.Report .VirtualTable-Container .VirtualTable,
.ClientSummaryReportAudit .VirtualTable-Container .VirtualTable,
.ReportDetails .VirtualTable-Container .VirtualTable {
  --vt-header-height: 3rem !important;
  --vt-row-height: 2.75rem !important;
  margin: -1px 0;
}
.Report .VirtualTable-Container .VirtualTable-Expand input[type=checkbox]:checked:before,
.Report .VirtualTable-Container .VirtualTable-Select input[type=checkbox]:checked:before,
.ClientSummaryReportAudit .VirtualTable-Container .VirtualTable-Expand input[type=checkbox]:checked:before,
.ClientSummaryReportAudit .VirtualTable-Container .VirtualTable-Select input[type=checkbox]:checked:before,
.ReportDetails .VirtualTable-Container .VirtualTable-Expand input[type=checkbox]:checked:before,
.ReportDetails .VirtualTable-Container .VirtualTable-Select input[type=checkbox]:checked:before {
  color: var(--bs-warning);
  background-color: transparent;
}
.Report .VirtualTable-Container .VirtualTable-Header .VirtualTable-Cell,
.ClientSummaryReportAudit .VirtualTable-Container .VirtualTable-Header .VirtualTable-Cell,
.ReportDetails .VirtualTable-Container .VirtualTable-Header .VirtualTable-Cell {
  color: #fff;
}
.Report .VirtualTable-Container .VirtualTable-Header .VirtualTable-Expand,
.Report .VirtualTable-Container .VirtualTable-Header .VirtualTable-Select,
.ClientSummaryReportAudit .VirtualTable-Container .VirtualTable-Header .VirtualTable-Expand,
.ClientSummaryReportAudit .VirtualTable-Container .VirtualTable-Header .VirtualTable-Select,
.ReportDetails .VirtualTable-Container .VirtualTable-Header .VirtualTable-Expand,
.ReportDetails .VirtualTable-Container .VirtualTable-Header .VirtualTable-Select {
  color: #fff;
}
.Report .VirtualTable-Container .VirtualTable-Header .VirtualTable-Expand input[type=checkbox]:checked:before,
.Report .VirtualTable-Container .VirtualTable-Header .VirtualTable-Select input[type=checkbox]:checked:before,
.ClientSummaryReportAudit .VirtualTable-Container .VirtualTable-Header .VirtualTable-Expand input[type=checkbox]:checked:before,
.ClientSummaryReportAudit .VirtualTable-Container .VirtualTable-Header .VirtualTable-Select input[type=checkbox]:checked:before,
.ReportDetails .VirtualTable-Container .VirtualTable-Header .VirtualTable-Expand input[type=checkbox]:checked:before,
.ReportDetails .VirtualTable-Container .VirtualTable-Header .VirtualTable-Select input[type=checkbox]:checked:before {
  color: var(--bs-warning);
  background-color: transparent;
}
.Report .VirtualTable-Container .VirtualTable-Cell span,
.ClientSummaryReportAudit .VirtualTable-Container .VirtualTable-Cell span,
.ReportDetails .VirtualTable-Container .VirtualTable-Cell span {
  font-weight: 600;
}
.Report .VirtualTable-Container + .Details .row .col,
.ClientSummaryReportAudit .VirtualTable-Container + .Details .row .col,
.ReportDetails .VirtualTable-Container + .Details .row .col {
  justify-content: start;
  gap: 2.5rem;
}`, "",{"version":3,"sources":["webpack://./src/pages/Reports/styles.scss"],"names":[],"mappings":"AACE;EACE,iBAAA;AAAJ;AAGI;EACE,kBAAA;AADN;AAIM;EACE,eAAA;AAFR;;AAOA;;;EAGE,kDAAA;AAJF;AAOM;;;EACE,UAAA;AAHR;AAOE;;;EACE,yCAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;AAHJ;AAII;;;EACE,mCAAA;EACA,mCAAA;EACA,cAAA;AAAN;AAMU;;;;;;EACE,wBAAA;EACA,6BAAA;AACZ;AAKM;;;EACE,WAAA;AADR;AAGM;;;;;;EAEE,WAAA;AAGR;AAAY;;;;;;EACE,wBAAA;EACA,6BAAA;AAOd;AAAM;;;EACE,gBAAA;AAIR;AACQ;;;EACE,sBAAA;EACA,WAAA;AAGV","sourcesContent":[".ClientSummaryReportAudit {\n  [selector='name'] {\n    text-align: start;\n  }\n  .VirtualTable-Expanded {\n    [selector='name'] {\n      text-align: center;\n    }\n    .VirtualTable-Expanded {\n      [selector='name'] {\n        text-align: end;\n      }\n    }\n  }\n}\n.Report,\n.ClientSummaryReportAudit,\n.ReportDetails {\n  font-family: Inter, sans-serif, Verdana !important;\n  .Details {\n    .row {\n      .col {\n        padding: 0;\n      }\n    }\n  }\n  .VirtualTable-Container {\n    --vt-header-background: var(--bs-primary);\n    border: 1px solid #ccc;\n    border-radius: 2px;\n    overflow: hidden;\n    .VirtualTable {\n      --vt-header-height: 3rem !important;\n      --vt-row-height: 2.75rem !important;\n      margin: -1px 0;\n    }\n    .VirtualTable-Expand,\n    .VirtualTable-Select {\n      input[type='checkbox'] {\n        &:checked {\n          &:before {\n            color: var(--bs-warning);\n            background-color: transparent;\n          }\n        }\n      }\n    }\n    .VirtualTable-Header {\n      .VirtualTable-Cell {\n        color: #fff;\n      }\n      .VirtualTable-Expand,\n      .VirtualTable-Select {\n        color: #fff;\n        input[type='checkbox'] {\n          &:checked {\n            &:before {\n              color: var(--bs-warning);\n              background-color: transparent;\n            }\n          }\n        }\n      }\n    }\n    .VirtualTable-Cell {\n      span {\n        font-weight: 600;\n      }\n    }\n    + .Details {\n      .row {\n        .col {\n          justify-content: start;\n          gap: 2.5rem;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
